export default __webpack_public_path__ + "static/media/GraphikMedium.f82d54aa.woff2";